<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex">

            <section class="mu-d-flex mu-flex-row">

                <h1 class="mu-mb-00">Audit history</h1>
                <details class="mcc-popover mcc-popover--bottom-end">
                    <summary class="mcc-button mcc-button--icon-only ">
                        <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                    </summary>
                    <div class="mcc-popover__content">

                        <p class="mu-mb-00">
                            {{ helpText.title }}
                            <a :href="helpText.url" target="_blank">Read more...</a>
                        </p>
                    </div>
                </details>
            </section>
            <section>

            </section>

        </div>
    </div>
    <div class="mcc-container--fluid card-padding">
        <nav aria-label="breadcrumb">
            <ol class="mcc-breadcrumb">
                <li>Administration</li>
                <li>
                    <a class="table-link" @click="redirectToList()">Audit history</a>
                </li>
                <li>Entity history</li>
                <li>{{ entityName }}</li>
                <li class="lastBredCrumpLi">

                </li>
            </ol>
        </nav>
        <Drawer ref="customFilter" @reset-filter="resetFilter()" @apply-filter="performFilter()" title="Entity History Filters">
            <div v-if="dataCall" class="spinner-overlay">
                <div class="spinner-background"></div>
                <div class="spinner-flex ">
                    <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                        <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5">
                        </circle>
                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                    </svg>
                </div>
            </div>

            <div v-show="!dataCall">
                <form id="formIdd">

                <div>
                    <div class="mfc-input-wrapper mu-d-block mfc-form-input-container drawer-input">
                        <label for="entityId">Entity ID</label>
                        <input @change="entityIDRef = $event.target.value" :value="entityIDRef" id="entityId" ref="entityID" type="number" name="entityId" min="0" max="999999999" placeholder="Entity ID">

                    </div>
                    <div class="mfc-input-wrapper mu-d-block mfc-form-input-container drawer-input">
                        <label for="revision">Revision</label>
                        <input @change="revisionRef = $event.target.value" :value="revisionRef" id="revision" ref="revision" type="number" name="revision" min="0" max="999999999" placeholder="Revision">

                    </div>
                    <legend class="mfc-label">Revision type</legend>

                    <div class="mfc-checkbox-wrapper mfc-form-input-container drawer-input">
                        <input :checked="isChecked('added')" @change="handleRevisionTypeChange($event)" type="checkbox" value="added" name="checkboxlist" id="addedCheck">
                        <label for="addedCheck">Added</label>

                    </div>
                    <div class="mfc-checkbox-wrapper mfc-form-input-container drawer-input">
                        <input :checked="isChecked('modified')" name="checkboxlist" id="modifiedCheck" @change="handleRevisionTypeChange($event)" type="checkbox" value="modified">
                        <label for="modifiedCheck">Modified</label>

                    </div>
                    <div class="mfc-checkbox-wrapper mfc-form-input-container drawer-input">
                        <input type="checkbox" value="deleted" name="checkboxlist" id="deletedCheck" :checked="isChecked('deleted')" @change="handleRevisionTypeChange($event)">
                        <label for="deletedCheck">Deleted</label>

                    </div>
                    <div class="mfc-slim-select-wrapper drawer-input drawer-input">
                        <label for="usernames">Modified by</label>
                        <select id="usernames" class="mfc-slim-select" @change="modifiedByRef = $event.target.value" name="usernames" block>
                            <option data-placeholder="true" value :selected="modifiedByRef == ''"></option>
                            <option v-for="(username, key) in modifiedBynames" :selected="modifiedByRef == username" :key="key" :value="username">
                                {{
                                                            username }}
                            </option>
                        </select>
                    </div>
                    <div class="flatpickr flatpickrGap mfc-input-wrapper drawer-input ">
                        <label for="changeDateId" class=" mb-0">Modified between</label>
                        <div class="mfc-input-group flatpickrDiv mfc-input-group--has-help-text mfc-input-group--has-validation-text    ">
                            <input name="changeDate" placeholder="Select Date.." id="changeDateId" class="flatpickrInstance flatpickr" data-input range ref="changeDate" block prepend icon="calendar" help-text @change="handleChangeRangeChange($event)" @ready="handleChangeRangeReady()">
                            <button type="button" class="mcc-button mcc-button--outline" data-toggle aria-label="date">
                                <mcc-icon name="calendar" aria-hidden="true"></mcc-icon>
                            </button>
                            <div id="mds_text_feedback" class="mfc-invalid-feedback">
                                <mcc-icon name="error" width="24" height="24"></mcc-icon>
                                <span>Please select proper dates.</span>
                            </div>
                        </div>
                    </div>

                </div>
            </form>

            </div>
        </Drawer>

        <div class="mcc-col">
            <div style="position:relative">
                <div v-if="!updateCall" class="spinner-overlay">
                    <div class="spinner-background"></div>
                    <div class="spinner-flex">
                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5">
                            </circle>
                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>
                <div class="mcc-card">

                            <div class="mcc-card__body">
                                <div class="mu-d-flex mu-justify-content-end mu-pb-06">
                                    <button class="mcc-button mcc-button--outline mcc-button--sm" @click="$refs.customFilter.open()">
                                        <mcc-icon name="filter" aria-hidden="true"></mcc-icon>
                                        <span class="mcc-button__label">Filters {{ filterCount > 0 ? '(' + filterCount + ')' : '' }}</span>
                                    </button>
                                </div>
                                <mcc-data-table ref="auditHistoryTable" id="auditHistoryTableId"></mcc-data-table>
                            </div>

                </div>
            </div>

        </div>

    </div>

</div>
</template>

<script>
import constantMessages from "../../../messages";
import Table from "@advanced/component-mosaic-table";
import AuditHistoryAPI from "../../../services/AuditHistoryAPI";
import Utils from "@/script_utils";
import Drawer from '../../common/Drawer.vue';
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../../formvalid.js';

import {
    EventBus
} from "../../../services/event-bus";
export default {
    name: "AuditHistoryEntity",
    components: {
        Drawer
    },
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["administration.audithistory.entity"],
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            updateDialog: false,
            tableObj: null,
            currentPageSize: 10,
            updateCall: true,
            entityName: this.$route.params.entityName,
            changeDateRangeRef: [],
            changeDateBefore: "",
            changeDateAfter: "",
            revisionRef: "",
            revision: "",
            entityIDRef: "",
            entityID: "",
            revisionTypeRef: [],
            revisionType: [],
            modifiedByRef: "",
            modifiedBy: "",
            modifiedBynames: {},
            headerNames: [],
            dataCall: true,
            flatPickerInstance: null,
            modifiedBySelect: null,
            filterCount: 0,
            tableData : [],
            filterActive: false,
            filterData: []
        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);

        let self = this;
        if (this.$route.query.entityId) {
            this.entityID = this.$route.query.entityId;
            this.entityIDRef = this.$route.query.entityId;
        }
        AuditHistoryAPI.getTableHeaders(self.entityName)
            .then(result => {
                self.headerNames = result;
                let pageTitle = constantMessages.PAGEHEADER_TITLE["menu.admin.entityHist"] + " - " + this.$route.params.entityName;
                EventBus.$emit("update-pageTitle", pageTitle);
            })
            .finally(() => {

                self.initAuditHistoryTable();
            });

        AuditHistoryAPI.getFilterDropdownData()
            .then(result => {
                self.modifiedBynames = result.modified_by;

            })
            .finally(() => {
                self.dataCall = false
                this.modifiedBySelect = new SlimSelect({
                    select: '#usernames',

                })
                self.flatPickr();
            });

    },
    updated() {
        this.flatPickr();
    },
    methods: {
        getFilterCount() {
            if (this.revisionRef != "")
                this.filterCount += 1
            if (this.entityIDRef != "")
                this.filterCount += 1
            if (this.revisionTypeRef != "")
                this.filterCount += 1
            if (this.modifiedByRef != "")
                this.filterCount += 1
            if (this.changeDateAfter != "")
                this.filterCount += 1

        },
        flatPickr() {
            let self = this;
            self.flatPickerInstance = flatpickr('.flatpickrDiv', {
                dateFormat: 'm/d/Y',
                altFormat: 'd/m/Y',
                altInput: true,
                mode: 'range',
                wrap:true,
                defaultDate: [self.changeDateRangeRef[0], self.changeDateRangeRef[1]],
            })
        },
        performFilter(e) {
            this.updateDateRef();
            this.filterCount = 0;
            this.getFilterCount();
            this.revisionType = this.revisionTypeRef;
            this.revision = this.revisionRef;
            this.entityID = this.entityIDRef;
            this.modifiedBy = this.modifiedByRef;
            this.initAuditHistoryTable();
            $('#formIdd').closest('#drawerOverlay').removeClass("mcc-drawer--open")
            $('#formIdd').closest('#drawerOverlay').addClass("mcc-drawer--closed")

        },
        isChecked(value) {
            return this.revisionTypeRef.includes(value);
        },
        updateDateRef() {
            this.changeDateAfter = "";
            this.changeDateBefore = "";
            if (this.changeDateRangeRef.length > 0) {
                let changeDateFrom = this.changeDateRangeRef[0];
                let changeDateTo = this.changeDateRangeRef[1];
                let d = new Date(changeDateFrom);
                d.setHours(0, -d.getTimezoneOffset(), 0, 0);
                this.changeDateAfter = d.toISOString();
                if (!changeDateTo) {
                    changeDateTo = changeDateFrom
                }
                d = new Date(changeDateTo);
                d.setHours(23, -d.getTimezoneOffset() + 59, 59, 999);
                this.changeDateBefore = d.toISOString();
            }
        },
        handleRevisionTypeChange(e) {
            if (e.target.checked) {
                if (!this.revisionTypeRef.includes(e.target.value)) {
                    this.revisionTypeRef.push(e.target.value);
                }
            } else {
                this.revisionTypeRef.splice(this.revisionTypeRef.indexOf(e.target.value), 1);
            }
        },
        handleChangeRangeChange(e) {
            this.changeDateRangeRef = "";
            if (e.target.value.length > 1) {

                this.changeDateRangeRef = e.target.value.split(' to ');
            }
        },
        handleChangeRangeReady() {
            if (this.changeDateRangeRef.length > 1) {
                this.$refs.changeDate.value =
                    moment(this.changeDateRangeRef[0]).format("DD/MM/YYYY") +
                    " to " +
                    moment(this.changeDateRangeRef[1]).format("DD/MM/YYYY");
            }
        },
        closeDialog() {
            this.$refs.filterDialog.close();
            this.updateDialog = false;
        },
        showDialog() {
            this.updateDialog = true;
        },
        showFilterDialog() {
            this.$refs.filterDialog.show();
            this.showDialog();
        },
        resetFilter() {
            this.filterCount = 0;
            this.updateCall = false;
            this.changeDateRangeRef = [];
            this.changeDateBefore = "";
            this.changeDateAfter = "";
            this.revisionRef = "";
            this.revision = "";
            if (this.$route.query.entityId) {
                this.entityID = this.$route.query.entityId;
                this.entityIDRef = this.$route.query.entityId;
            } else {
                this.entityIDRef = "";
                this.entityID = "";
            }
            this.modifiedBySelect.setSelected('');
            flatpickr("#changeDateId").destroy();
            this.flatPickr();
            this.modifiedBy = "";
            this.revisionType = [];
            this.revisionTypeRef = [];
            this.initAuditHistoryTable();

        },
        initAuditHistoryTable() {
            let self = this;
            let prop = {};
            for (let i = 0; i < self.headerNames.length; i++) {
                let lowerCaseHeaderName = self.headerNames[i].replace(/([a-z](?=[A-Z]))/g, '$1 ').toLowerCase();
                prop[i] = {
                    type: "string",
                    title: lowerCaseHeaderName[0].toUpperCase() + lowerCaseHeaderName.slice(1),
                    sortable: false,
                    columnSearch: false
                };
            }
            if (self.tableObj != null) {
                self.currentPageSize = self.tableObj.tableContext.store.state.pageSize;
            }
            const table = document.getElementById("auditHistoryTableId");
            self.tableObj = window.tableFactory.create(table, {
                bordered: true,
                striped: true,
                fixedHeight: true,
                emptyTemplate: '<p class="text-center m-0">No audit history found</p>',
                loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                columnSearch: false,
                pageSize: self.currentPageSize,
                debounceTime: 1000,
                schema: {
                    properties: prop
                },
                data: (
                    start,
                    limit,
                    sortHeader,
                    sortDirection,
                    fullTextQuery,
                    searchColumns
                ) => {
                    if (!self.filterActive) {
                        self.updateCall = false;
                        if (self.tableObj != null) {
                            self.currentPageSize =
                                self.tableObj.tableContext.store.state.pageSize;
                        }
                        let queryString =
                            "start=" +
                            start +
                            "&length=" +
                            self.currentPageSize +
                            "&revision=" +
                            self.revision +
                            "&username=" +
                            encodeURI(self.modifiedBy) +
                            "&entityID=" +
                            self.entityID;
                        if (self.changeDateAfter != "") {
                            queryString +=
                                "&startDate=" +
                                self.changeDateAfter +
                                "&endDate=" +
                                this.changeDateBefore;
                        }

                        return AuditHistoryAPI.getEntityAuditHistory(queryString, self.entityName, self.revisionType).then(result => {
                            let responseData = {
                                totalCount: 0,
                                data: []
                            };
                            responseData.totalCount = result.page.totalElements;
                            if (result.data != null) {
                                responseData.data = result.data;
                            }
                            self.updateCall = true;
                            self.tableData = responseData.data;
                            return responseData;
                        });
                    } else{
                        self.filterActive = false;
                        let responseData = {
                            totalCount: self.filterData.length,
                            data: self.filterData
                        };
                        return responseData;
                    }
                }
            });

        },
        redirectToList() {
            localStorage.setItem("auditList", "auditList");

            this.$router.push(
                this.CONTEXT_PATH + '/admin/audit'
            );
        }
    }
};
</script>

<style scoped>
.mfc-slim-select-wrapper label {
    margin-bottom: 0px;
}

.mfc-input-group input[readonly] {
    background-color: #e9ecef;
    opacity: 1;
}

.flatpickrGap {
    gap: 0.25rem;
}
</style>
